module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a8WfH"))).then(() => parcelRequire('1iHdE'));